import { useEffect, useState } from 'react';

/** Returns false until `delayMs` has elapsed while `active` is true. */
export function useDelayedTrue(active: boolean, delayMs: number): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!active) {
      setReady(false);
      return;
    }

    const id = window.setTimeout(() => setReady(true), delayMs);
    return () => window.clearTimeout(id);
  }, [active, delayMs]);

  return active && ready;
}
